import { render, staticRenderFns } from "./restrictiveComponent.vue?vue&type=template&id=57e46a5b"
import script from "./restrictiveComponent.vue?vue&type=script&lang=ts"
export * from "./restrictiveComponent.vue?vue&type=script&lang=ts"
import style0 from "./restrictiveComponent.vue?vue&type=style&index=0&id=57e46a5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports